import { omit } from 'lodash';

const DOCUMENT_MAPPING_READONLY_FIELDS = ['__typename', 'order', 'document'];

/**
 * Document mapping rows and delete keys for `UPSERT_ORDERS`. An array (even empty) replaces
 * the order's mappings. Anything else means the order was fetched without `documents`, so
 * nothing is deleted or inserted; treating that as `[]` would wipe every attachment.
 * Read `documents` off the order before `ORDER_READONLY_FIELDS` is omitted, since it is listed there.
 *
 * @param {Object} args
 * @param {Object[]|undefined} args.documents The edited `documents` list.
 * @param {string} [args.orderId] The order's id; absent on a new order.
 * @returns {{documents: Object[], orderIds: string[]}} Rows to insert, and the order ids whose
 *     mappings `delete_document_mappings` removes.
 */
export const buildDocumentsSavePayload = ({ documents, orderId }) => {
    if (!Array.isArray(documents)) {
        return { documents: [], orderIds: [] };
    }

    return {
        documents: documents.map((mapping) => ({
            ...omit(mapping, DOCUMENT_MAPPING_READONLY_FIELDS),
            // New rows checked in AdditionalDocuments carry no order_id until the order
            // exists; mapping_id is left alone so an existing row keeps its identity
            // across the delete/re-insert.
            ...(orderId ? { order_id: orderId } : {}),
        })),
        orderIds: orderId ? [orderId] : [],
    };
};
